<div #summary>
  <section class="text-center mobi-ui-section-minor mobi-ui-margin-b-sm">
    <h3 class="mobi-ui-font-h2">
      {{ element['#title'] }}
    </h3>
    @if (element['#lead']) {
      <p>
        {{ element['#lead'] }}
      </p>
    }
  </section>
  <section class="mobi-ui-section-minor mobi-ui-ink-grey is-background">
    @if (plugin === 'uvg_prime_calc') {
      <webform-summary-uvg
        class="block mobi-ui-margin-t-lg"
        [formId]="formId"
      ></webform-summary-uvg>
    }
    @if (plugin === 'bike_prime_calc') {
      <webform-summary-bike
        class="block mobi-ui-margin-t-lg"
        [formId]="formId"
      ></webform-summary-bike>
    }
    @if (plugin === 'cyber_prime_calc') {
      <webform-summary-cyber
        class="block mobi-ui-margin-t-lg"
        [formId]="formId"
      ></webform-summary-cyber>
    }
  </section>
</div>
